import { sharedUrls } from './environment.urls';
import { REVISION, VERSION } from './revision';

export const environment = {
  gtmContainerId: 'GTM-WZXPXV73',
  analyticsEnv: 'dev-2',
  firebase: {
    apiKey: "AIzaSyAMUlmH4gkvLvvI_E6DMSEDLTyL5YdaY-o",
    authDomain: "spog-gopher-dev-2-231d.firebaseapp.com",
    projectId: "spog-gopher-dev-2-231d",
    storageBucket: "spog-gopher-dev-2-231d.firebasestorage.app",
    messagingSenderId: "627812374728",
    appId: "1:627812374728:web:cae2f7eef247fa6715edfd"
  },
  urls: {
    backendApi: 'https://spog-backend.dev-2.gopher.cdw.com/api',
    ...sharedUrls,
  },
  production: false,
  revision: REVISION,
  version: VERSION,
};
